import {NgModule} from '@angular/core';

import {ThemeComponent} from './theme.component';

@NgModule({
  imports: [ThemeComponent],
  exports: [ThemeComponent],
})
export class ThemeModule {}
